import { BaseRESTService } from '../../common/services/BaseRESTService';

export class ApiRepository extends BaseRESTService {
  async resetKey(): Promise<string> {
    const { data } = await this.post('/api/internal/reset_api_key', {});
    return data.apiKey;
  }
}
